export function isFormPage(url: string) {
  if (url.includes('/comparable/apartments/add') || url.includes('/comparable/apartments/edit')) {
    return true
  }

  if (url.includes('/comparable/houses/add') || url.includes('/comparable/houses/edit')) {
    return true
  }

  if (url.includes('/comparable/offices/add') || url.includes('/comparable/offices/edit')) {
    return true
  }

  if (url.includes('/comparable/retail-shops/add') || url.includes('/comparable/retail-shops/edit')) {
    return true
  }

  if (url.includes('/comparable/retail-buildings/add') || url.includes('/comparable/retail-buildings/edit')) {
    return true
  }

  if (url.includes('/comparable/parkings/add') || url.includes('/comparable/parkings/edit')) {
    return true
  }

  if (url.includes('/comparable/warehouses/add') || url.includes('/comparable/warehouses/edit')) {
    return true
  }

  if (url.includes('/admin-management/agencies/edit') || url.includes('/admin-management/agencies/add')) {
    return true
  }

  return false
}